import { createContext } from "react";

const BroadcastContext = createContext(5);
export default BroadcastContext;